import { Component, OnInit, Output, EventEmitter, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { GlobalObservables } from '../../../../../app.global.observer';
import { HelperService } from '../../../services/helper.service';
import { Global } from '../../../../../app.global';
import { KeyDescriptionViewModel } from '../../../viewmodels/keyDescriptionViewModel';

import { RadioQuestionModel, SelectQuestionModel } from '../../../viewmodels/policy-item.model';
import { ConcessionsOtherCopy } from '../../../helper/textcopy/policies.text';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'concessions-other-policy',
  templateUrl: './concessions-other.component.html',
})
export class ConcessionsOtherComponent implements OnInit, OnDestroy {
  // eslint-disable-next-line @angular-eslint/no-output-on-prefix
  @Output() onSavePolicies = new EventEmitter();
  policiesAnswersSetted = new Subscription();
  policiesAnswers: any = this.global.policiesAnswers;

  textCopy = ConcessionsOtherCopy;

  radioOne = new RadioQuestionModel();
  radioTwo = new RadioQuestionModel();
  radioThree = new RadioQuestionModel();
  radioFour = new RadioQuestionModel();
  radioFive = new RadioQuestionModel();
  radioSix = new RadioQuestionModel();
  radioSeven = new RadioQuestionModel();
  selectQuestion = new SelectQuestionModel();

  constructor(
    public global: Global,
    private globalObs: GlobalObservables,
    private helpServ: HelperService
  ) {}

  ngOnInit() {
    this.setRadioOneQuestion();
    this.setRadioTwoQuestion();
    this.setRadioThreeQuestion();
    this.setRadioFourQuestion();
    this.setRadioFiveQuestion();
    this.setRadioSixQuestion();
    this.setRadioSevenQuestion();
    this.setSelectQuestion();

    if (this.helpServ.isEmpty(this.policiesAnswers)) {
      this.onPoliciesAnswersSetted();
    } else {
      this.setSelectedValues();
    }
  }

  setRadioOneQuestion() {
    this.radioOne.data = {
      title: this.textCopy.radioTitleOne,
      includeTitle: true,
      answers: [
        { text: 'yes', value: 'y' },
        { text: 'no', value: 'n' },
      ],
    };
  }
  onRadioOneSelected(answerValue) {
    this.radioOne.valueSelected = answerValue;
  }

  setRadioTwoQuestion() {
    this.radioTwo.data = {
      title: this.textCopy.radioTitleTwo,
      includeTitle: true,
      answers: [
        { text: 'accept them', value: '0' },
        { text: 'return them to owners', value: '1' },
      ],
    };
  }
  onRadioTwoSelected(answerValue) {
    this.radioTwo.valueSelected = answerValue;
  }

  setRadioThreeQuestion() {
    this.radioThree.data = {
      title: this.textCopy.radioTitleThree,
      includeTitle: true,
      answers: [
        { text: 'yes', value: '0' },
        {
          text: "no, we write back and say it's the registered keeper who needs to write in",
          value: '1',
        },
        { text: 'sometimes', value: '2' },
      ],
    };
  }
  onRadioThreeSelected(answerValue) {
    this.radioThree.valueSelected = answerValue;
  }

  setRadioFourQuestion() {
    this.radioFour.data = {
      title: this.textCopy.radioTitleFour,
      includeTitle: true,
      answers: [
        { text: 'request death certificate', value: '0' },
        { text: 'cancel PCN and express condolences', value: '1' },
      ],
    };
  }
  onRadioFourSelected(answerValue) {
    this.radioFour.valueSelected = answerValue;
  }

  setRadioFiveQuestion() {
    this.radioFive.data = {
      title: this.textCopy.radioTitleFive,
      includeTitle: true,
      beforeText: this.textCopy.radioSubtitleFive,
      answers: [
        { text: 'yes', value: 'y' },
        { text: 'no', value: 'n' },
      ],
    };
  }
  onRadioFiveSelected(answerValue) {
    this.radioFive.valueSelected = answerValue;
  }

  setRadioSixQuestion() {
    this.radioSix.data = {
      title: this.textCopy.radioTitleSix,
      includeTitle: true,
      answers: [
        { text: 'yes', value: 'y' },
        { text: 'no', value: 'n' },
      ],
    };
  }
  onRadioSixSelected(answerValue) {
    this.radioSix.valueSelected = answerValue;
  }

  setRadioSevenQuestion() {
    this.radioSeven.data = {
      title: this.textCopy.radioTitleSeven,
      includeTitle: true,
      answers: [
        { text: 'uphold the PCN', value: '0' },
        {
          text: 'cancel the PCN if they provide a satisfactory letter from their doctor or hospital',
          value: '1',
        },
      ],
    };
  }
  onRadioSevenSelected(answerValue) {
    this.radioSeven.valueSelected = answerValue;
  }

  setSelectQuestion() {
    const answers = [];
    for (let i = 0; i < 21; i++) {
      answers.push({
        id: i.toString(),
        value: i.toString(),
      });
    }
    this.selectQuestion.data = {
      title: this.textCopy.selectTitle,
      includeTitle: true,
      answers,
    };
  }
  onSelectQuestionSelected(answerValue) {
    this.selectQuestion.valueSelected = answerValue;
  }

  setSelectedValues() {
    this.radioOne.valueSelected = this.policiesAnswers['12_2'];
    this.radioTwo.valueSelected = this.policiesAnswers['12_3'];
    this.radioThree.valueSelected = this.policiesAnswers['12_4'];
    this.radioFour.valueSelected = this.policiesAnswers['12_8'];
    this.radioFive.valueSelected = this.policiesAnswers['12_9'];
    this.radioSix.valueSelected = this.policiesAnswers['12_10'];
    this.radioSeven.valueSelected = this.policiesAnswers['12_11'];
    this.selectQuestion.valueSelected = this.policiesAnswers['12_1'];
  }

  onPoliciesAnswersSetted() {
    this.policiesAnswers = this.global.policiesAnswers;
    this.policiesAnswersSetted = this.globalObs.onPoliciesAnswersSetted.subscribe(() => {
      this.setSelectedValues();
    });
  }

  submitPolicyCategory() {
    let policyList = new Array<KeyDescriptionViewModel>();
    policyList = [
      { id: '12_2', description: this.radioOne.valueSelected },
      { id: '12_3', description: this.radioTwo.valueSelected },
      { id: '12_4', description: this.radioThree.valueSelected },
      { id: '12_8', description: this.radioFour.valueSelected },
      { id: '12_9', description: this.radioFive.valueSelected },
      { id: '12_10', description: this.radioSix.valueSelected },
      { id: '12_11', description: this.radioSeven.valueSelected },
      { id: '12_1', description: this.selectQuestion.valueSelected },
    ];

    this.onSavePolicies.emit(policyList);
  }

  ngOnDestroy() {
    if (this.helpServ.isEmpty(this.policiesAnswers)) {
      this.policiesAnswersSetted.unsubscribe();
    }
  }
}
